import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bug"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M17 9H7V16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16V9Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M12 2C9.79086 2 8 3.79086 8 6H16C16 3.79086 14.2091 2 12 2Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 13H4M7 13V16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16V13M7 13V9H17V13M20 13H17M12 9V20M6.55 16.45L4 19V21M17.45 16.45L20 19V21M6.65 9.65L4 7V5M17.35 9.65L20 7V5M8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6H8Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Bug = Vue.extend<IconProps>({
  name: 'BugIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bug',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Bug;
